import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  OPERATOR: 'ORANGE',
  [APP_ENV.development]: {
    API: '',
    SENTRY: '',
    BACK_URL: '/'
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: 'https://237696e8e9c244cf835ba834a61d25a7@error.blue.pl/128',
    BACK_URL: '/'
  }
}
